import { render, staticRenderFns } from "./TopAgent.vue?vue&type=template&id=255d434c&scoped=true&"
import script from "./TopAgent.vue?vue&type=script&lang=js&"
export * from "./TopAgent.vue?vue&type=script&lang=js&"
import style0 from "./TopAgent.vue?vue&type=style&index=0&id=255d434c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d434c",
  null
  
)

export default component.exports